<script>
import CandelaControl from '@/components/controls/CandelaControl'
export default {
  data() {
    return {
      internal_value: ''
    }
  },
  extends: CandelaControl,
  name: 'candela-text-input',
  methods: {
    on_input() {
      this.value = this.internal_value
      this.on_value_change()
    }
  },
  mounted() {
    this.on_mounted()
    this.internal_value = this.value
  },
  props: {
    label: {type: String, default: () => 'Untitled'},
    multiline: {type: Boolean, default: () => false},
    rows: {type: Number, default: () => 6}
  }
}
</script>
<template>
<div class='d-flex align-center flex-grow-1 flex-shrink-0'>
  <v-textarea v-if='multiline' v-model='internal_value'
    @click:append-outer='on_input'
    v-on:keydown.enter='on_input'
    :label='label' :rows='rows' append-outer-icon='keyboard_arrow_right'
    hide-details outlined/>
  <v-text-field v-else v-model='internal_value'
    @click:append-outer='on_input'
    v-on:keydown.enter='on_input' :label='label'
    append-outer-icon='keyboard_arrow_right' hide-details outlined/>
</div>
</template>
